import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { IconByName } from "../IconByName";
import { resources } from "../../data/content";
export function ResourcesSection() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-276" data-mp="26z2dekwua4t0">
      <div className="mx-auto max-w-4xl" data-id="element-277" data-mp="2by5exvdm1sw8">
        <SectionHeading kicker="Practical clinical resources" title="More Than Reading Material — Tools You Can Actually Consult" lead="Inside the collection, you'll find educational resources designed to make clinical information easier to organize and review." data-id="element-278" data-mp="2bx3vb2ij3y2w" />
        <ul className="mt-10 divide-y divide-navy-950/10 rounded-3xl bg-mist px-5" data-id="element-279" data-mp="1o6q93smmktg8">
          {resources.map(r => <li key={r.title} className="flex items-start gap-4 py-5" data-id="element-280" data-mp="1t0m6otyz8eav">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand text-white" data-id="element-281" data-mp="viud6q4vr5ki">
                <IconByName name={r.icon} className="h-6 w-6" data-id="element-282" data-mp="10gds7s9ejmdi" />
              </span>
              <div data-id="element-283" data-mp="1i9m5dhasobgc">
                <h3 className="font-display text-[18px] font-extrabold leading-snug text-navy-950" data-id="element-284" data-mp="1ic8bdci1eiwg">{r.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-285" data-mp="19i3of460xrm7">{r.body}</p>
              </div>
            </li>)}
        </ul>
        <SectionCta label="Give me the clinical tools now" note="Consult them anytime, from any device" data-id="element-286" data-mp="14i7nxewjcibe" />
      </div>
    </section>;
}